import React, { FC, useCallback } from 'react'
import { observer } from 'mobx-react'
import { IonContent, useIonViewWillEnter } from '@ionic/react'
import i18n from 'i18next'
import { doProductMobx, cartMobx, shopcartMobx, doMallProductMobx } from 'mobx/mall'
import { toast, useHistoryNew } from '@utils'
import { DetailInfo, Footer, RecommendProduct } from '..'
import { MallController, TCheckoutType } from '@ctrls/mallController'
import { BackPageBtn } from '@cps'
import { decorationMobx } from '@mobxStore'

interface IProps {
  disableScale?: boolean;
}

const ProductDetail: FC<IProps> = ({ disableScale }) => {
  const { name, intro, picBig, picHeight, picWidth, allergys, tags, no, saleCnt, pk, isCanTogo, pics } = doProductMobx.doProduct
  const history = useHistoryNew()

  const handleBack = () => {
    if (history.action === 'PUSH') {
      history.goBack()
    } else {
      history.replace('/mall')
    }
  }
  const handleToCheckout = () => {
    MallController.goCheckout()
  }

  const scrollTop = useCallback(() => {
    const productContent: any = document.getElementById('mallProductContent')
    productContent.scrollToPoint(0, 0, 0)
  }, [doProductMobx.doProduct.no])

  useIonViewWillEnter(() => {
    scrollTop()
  }, [])

  const handleScollWrong = () => {
    const productContent: any = document.getElementById('mallProductContent')
    const childNodes: any = document.querySelector(
      '.choose-modify-list'
    )?.childNodes
    const index = doProductMobx.doProduct.modifierGroups.findIndex(
      (group) => !group.isReady
    )
    if (productContent && childNodes && ~index) {
      productContent.scrollToPoint(0, childNodes[index].offsetTop, 300)
    }
    document.querySelector('ion-content').scrollToBottom()
  }

  return (
    <>
      <IonContent id='mallProductContent'>
        <BackPageBtn onClick={handleBack} />
        <DetailInfo
          no={no}
          imgUrl={picBig}
          pics={pics}
          picHeight={picHeight}
          picWidth={picWidth}
          name={name}
          intro={intro}
          allergys={allergys}
          tags={tags}
          statSaleCnt={
            decorationMobx.mallGlobalDecorates.showMonthSales ? doMallProductMobx.doProduct.statSaleCnt : 0
          }
          cnt={doProductMobx.doProduct.cnt}
          totalPrice={doProductMobx.doProductResult.totalPrice}
          totalActualPrice={doProductMobx.doProductResult.totalActualPrice}
        >
        </DetailInfo>
        <RecommendProduct productNo={no} />
      </IonContent>
      <Footer
        disableScale={disableScale}
        disabled={!doProductMobx.doProductResult.isReady}
        soldOut={doProductMobx.doProduct.saleCnt === 0}
        addToCart={(type: TCheckoutType = TCheckoutType.Buy) => {
          if (doProductMobx.doProductResult.isReady) {
            if (doProductMobx.doProduct && doProductMobx.doProduct.cnt) {
              if (type === TCheckoutType.Cart) {
                shopcartMobx.addToShopCart(doProductMobx.doProduct)
                toast({ message: i18n.t('productdetail.addCartSuccess') })
                return
              } else {
                cartMobx.addToCart(doProductMobx.doProduct, type)
              }
            } else {
              cartMobx.remove(doProductMobx.doProduct.pk)
            }
            handleToCheckout()
          } else {
            handleScollWrong()
          }
        }}
      />
    </>
  )
}

export default observer(ProductDetail)
